module.exports = __webpack_public_path__ + "static/media/buffet1.5385d89b.jpg";